export var Module;
(function (Module) {
    Module["AVATAR"] = "avatar";
    Module["CHAR_BASE"] = "char_base";
    Module["CHAR"] = "char";
    Module["CHAR_SKIN"] = "char_skin";
    Module["CHAR_TOKEN"] = "char_token";
    Module["BRAND"] = "brand";
    Module["CHAR_SKILL"] = "char_skill";
    Module["UNIEQUIP"] = "uniequip";
    Module["ITEM"] = "item";
    Module["ROGUELIKE"] = "roguelike";
    Module["ROGUELIKE_ITEM"] = "roguelike_item";
    Module["MEDAL"] = "medal";
    Module["GAME_MODE"] = "game_mode";
    Module["SPECIAL"] = "special";
    Module["NAME_CARD"] = "name_card";
})(Module || (Module = {}));
export var RoguelikeCategory;
(function (RoguelikeCategory) {
    RoguelikeCategory["BAND"] = "band";
})(RoguelikeCategory || (RoguelikeCategory = {}));
export var CharBaseCategory;
(function (CharBaseCategory) {
    CharBaseCategory["SUBPROFESSION"] = "subprofession";
})(CharBaseCategory || (CharBaseCategory = {}));
export var CharAssetCategory;
(function (CharAssetCategory) {
    CharAssetCategory["AVATAR"] = "avatar";
    CharAssetCategory["PORTRAIT"] = "portrait";
    CharAssetCategory["ILLUSTRATION"] = "illustration";
    CharAssetCategory["META"] = "meta";
})(CharAssetCategory || (CharAssetCategory = {}));
export var GameModeCategory;
(function (GameModeCategory) {
    GameModeCategory["ACTIVITY"] = "activity";
    GameModeCategory["CAMPAIGN"] = "campaign";
    GameModeCategory["CLIMB_TOWER"] = "climb_tower";
    GameModeCategory["ROGUELIKE"] = "roguelike";
})(GameModeCategory || (GameModeCategory = {}));
export var GameModeSubCategory;
(function (GameModeSubCategory) {
    GameModeSubCategory["THUMB"] = "thumb";
    GameModeSubCategory["ICON"] = "icon";
    GameModeSubCategory["ZONE_ICON"] = "zone_icon";
})(GameModeSubCategory || (GameModeSubCategory = {}));
export var UniEquipCategory;
(function (UniEquipCategory) {
    UniEquipCategory["TYPE"] = "type";
})(UniEquipCategory || (UniEquipCategory = {}));
export var UniEquipSubCategory;
(function (UniEquipSubCategory) {
    UniEquipSubCategory["ICON"] = "icon";
    UniEquipSubCategory["SHINING"] = "shining";
})(UniEquipSubCategory || (UniEquipSubCategory = {}));
export var NameCardCategory;
(function (NameCardCategory) {
    NameCardCategory["BG"] = "bg";
    NameCardCategory["SHORT"] = "short";
    NameCardCategory["LONG"] = "long";
})(NameCardCategory || (NameCardCategory = {}));
